import React from 'react';
import AffiliateCouponCodesTab from '@/components/affiliate/AffiliateCouponCodesTab';

const AffiliateCouponCodes = () => {
  return (
    <div className="p-6 space-y-6">
      <AffiliateCouponCodesTab />
    </div>
  );
};

export default AffiliateCouponCodes;